/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import throttle from 'lodash.throttle';
import Cookie from 'utils/cookies';
import { getMsidFromPath } from '../../../utils/common';
import s from './FloatingOpenInApp.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class FloatingOpenInApp extends React.Component {
  constructor() {
    super();
    this.state = {
      deepLinkUrl: undefined,
    };
  }

  generateOneLinkURL = () => {
    const { isEtimes, subSecSeoLocation } = this.props;

    let pageType = '';
    let msid = '';
    // console.log('onelink:', this.props.msid, subSecSeoLocation);
    if (
      typeof window !== 'undefined' &&
      window.location &&
      window.location.href
    ) {
      msid = getMsidFromPath(window.location.href);
    }
    if (
      !msid &&
      this.props.msid &&
      (this.props.pageType === 'ARTICLESHOW' ||
        this.props.pageType === 'LIVEBLOG')
    ) {
      msid = this.props.msid;
    }

    const afAndroidStoreCsl = subSecSeoLocation ? `01${subSecSeoLocation}` : isEtimes ? '01etimes': false;
    const afIosStoreCpp = subSecSeoLocation ? `01${subSecSeoLocation}` : isEtimes ? '01etimes': false;

    let afSub1 =
      typeof window === 'object' && window?.grxParams?.storySection
        ? window?.grxParams?.storySection
        : false;
    if (
      !afSub1 &&
      subSecSeoLocation &&
      (this.props.pageType === 'ARTICLESHOW' ||
        this.props.pageType === 'LIVEBLOG')
    ) {
      afSub1 = subSecSeoLocation;
    }

    const grxId = this.props.grxId || Cookie.get('_grx');

    let defaultValue;
    if (this.props.pageType === 'ARTICLESHOW') {
      pageType = isEtimes ? 'Etimes_Mweb_AS_Floating' : 'TOI_Mweb_AS_Floating';
      defaultValue = encodeURIComponent(
        `toiapp://open-$|$-id=${msid}-$|$-url=https://plus.timesofindia.com/toi-feed/feed/toia/article/show?id=${msid}&source=toi&fv=<fv>-$|$-type=news-$|$-pid=${pageType}-$|$-af_android_store_csl=${afAndroidStoreCsl}-$|$-af_ios_store_cpp=${afIosStoreCpp}-$|$-af_sub1=${afSub1}-$|$-af_sub2=${msid}-$|$-GRxID=${grxId}|$-utm_source=${pageType}`,
      );
    } else if (this.props.pageType === 'LIVEBLOG') {
      pageType = isEtimes ? 'Etimes_Mweb_LB_Floating' : 'TOI_Mweb_LB_Floating';
      defaultValue = encodeURIComponent(
        `toiapp://open-$|$-id=${msid}-$|$-type=liveblog-$|$-pid=${pageType}-$|$-af_android_store_csl=${afAndroidStoreCsl}-$|$-af_ios_store_cpp=${afIosStoreCpp}-$|$-af_sub1=${afSub1}-$|$-af_sub2=${msid}-$|$-GRxID=${grxId}-$|$-domain=t-$|$-utm_source=${pageType}`,
      );
    } else if (this.props.pageType === 'Home') {
      pageType = isEtimes ? 'Etimes_Mweb_HP_Floating' : 'TOI_Mweb_HP_Floating';
      defaultValue = !isEtimes
        ? encodeURIComponent(
            `toiapp://open-$|$-id=home-$|$-pid=${pageType}-$|$-af_android_store_csl=${afAndroidStoreCsl}-$|$-af_ios_store_cpp=${afIosStoreCpp}-$|$-af_sub1=${afSub1}-$|$-af_sub2=${msid}-$|$-GRxID=${grxId}|$-utm_source=${pageType}`,
          )
        : encodeURIComponent(
            `toiapp://open-$|$-id=Etimes-01-$|$-pid=${pageType}-$|$-af_android_store_csl=${afAndroidStoreCsl}-$|$-af_ios_store_cpp=${afIosStoreCpp}-$|$-af_sub1=Etimes-$|$-af_sub2=${msid}-$|$-GRxID=${grxId}-$|$-type=BottomBarDeepLink|$-utm_source=${pageType}`,
          );
    } else if (this.props.pageType === 'EtimesListing') {
      pageType = 'Etimes_Mweb_PG_Floating';
      defaultValue = encodeURIComponent(
        `toiapp://open-$|$-id=Etimes-01-$|$-pid=${pageType}-$|$-af_android_store_csl=${afAndroidStoreCsl}-$|$-af_ios_store_cpp=${afIosStoreCpp}-$|$-af_sub1=Etimes-$|$-af_sub2=${msid}-$|$-GRxID=${grxId}-$|$-type=BottomBarDeepLink|$-utm_source=${pageType}`,
      );
    }
    let extraparams = '';
    if (
      this.props.pageType === 'LIVEBLOG' ||
      this.props.pageType === 'ARTICLESHOW'
    ) {
      extraparams = `&af_ios_store_cpp=${afIosStoreCpp}&af_sub1=${afSub1}&af_sub2=${msid}`;
    }

    if (this.props.pageType === 'Home') {
      extraparams = !isEtimes
        ? `&af_ios_store_cpp=${afIosStoreCpp}&af_sub1=&af_sub2=`
        : `&af_ios_store_cpp=${afIosStoreCpp}&af_sub1=Etimes&af_sub2=`;
    }

    if (this.props.pageType === 'EtimesListing') {
      extraparams = `&af_ios_store_cpp=${afIosStoreCpp}&af_sub1=Etimes&af_sub2=`;
    }

    const oneLinkURL = 'https://timesofindia.onelink.me/mjFd/';

    const staticDeeplinkUrl = `${oneLinkURL}?af_js_web=true&af_ss_ver=2_7_2&pid=${pageType}&deep_link_value=${defaultValue}&af_dp=toiapp.appsflyer.deeplink://${extraparams}`;

    return staticDeeplinkUrl;
  };

  handleShow = () => {
    if (this.state.currentWindowUrl !== window?.location?.href) {
      this.setDeepLinkUrl();
    }
  };

  componentDidMount() {
    this.setDeepLinkUrl();
    this.throttledOnScroll = throttle(this.handleShow, 300);
    window.addEventListener('scroll', this.throttledOnScroll);
  }

  setDeepLinkUrl = () => {
    const deepLink = this.generateOneLinkURL();
    this.setState({
      deepLinkUrl: deepLink,
      currentWindowUrl: window?.location?.href,
    });
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledOnScroll);
  }

  handleOpenInAppClick = (event, appDeepLinkUrl) => {
    event.preventDefault();
    const { pageType, isEtimes } = this.props;
    let gaAction;
    if (!pageType) {
      gaAction = 'sticky_footer_open_toi_app';
    } else if (pageType === 'ARTICLESHOW') {
      gaAction = 'mweb_AS';
    } else if (pageType === 'LIVEBLOG') {
      gaAction = 'mweb_liveblog';
    } else if (pageType === 'Home') {
      gaAction = 'mweb_home';
    } else if (pageType === 'Listing') {
      gaAction = 'mweb_listing';
    } else {
      gaAction = 'sticky_footer_open_toi_app';
    }
    if (isEtimes && pageType === 'ARTICLESHOW') {
      sendGaThroughProps({
        data: {
          gaAction: 'click-openapp',
          gaLabel: 'cta_click',
        },
      });
    } else {
      sendGaThroughProps({
        data: {
          gaCategory: `ContinueAppFloatingIcon`,
          gaAction,
          gaLabel: `${window?.location?.href}`,
        },
      });
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'continue_on_app_CTA',
      category: 'floating_cta',
      label: 'Continue On App',
    });
    window.location.href = appDeepLinkUrl;
  };

  render() {
    const showStickyClass = s['show-sticky'];

    let appDeepLinkUrl = this.state.deepLinkUrl;
    if (!appDeepLinkUrl) {
      appDeepLinkUrl = this.generateOneLinkURL();
    }

    if (!appDeepLinkUrl) {
      return null;
    }
    if (typeof window !== 'undefined' && !this.state.inViewEvent) {
      setTimeout(() => {
        if (!this.state.inViewEvent) {
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: 'continue_on_app_CTA',
            category: 'floating_cta',
            label: 'Continue on App',
          });
          this.setState({
            inViewEvent: true,
          });
        }
      }, 100);
    }
    return this.state.inViewEvent ? (
      <div className={`${s.openinapp} ${showStickyClass}`}>
        <a
          href={appDeepLinkUrl}
          onClick={e => this.handleOpenInAppClick(e, appDeepLinkUrl)}
        >
          Continue on App
        </a>
      </div>
    ) : null;
  }
}

FloatingOpenInApp.propTypes = {
  pageType: PropTypes.string.isRequired,
  isEtimes: PropTypes.bool,
  grxId: PropTypes.string,
};

FloatingOpenInApp.defaultProps = {
  isEtimes: false,
  grxId: '',
};

export default FloatingOpenInApp;
